import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RegistrationData, RegistrationState } from '@/types/Registration';

const initialState: RegistrationState = {
  data: {},
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    setData(state, action: PayloadAction<Partial<RegistrationData>>) {
      state.data = { ...state.data, ...action.payload };
    },
    clearRegistrationData(state) {
      state.data = {};
    },
  },
});

export const { setData, clearRegistrationData } =
  registrationSlice.actions;

export default registrationSlice.reducer;
